/**
 *
 * EditableField
 *
 */

import { withStyles } from '@material-ui/core/styles'
import { Edit } from '@material-ui/icons'
/* eslint-disable lines-between-class-members, react/destructuring-assignment, no-unused-expressions */
import cn from 'classnames'
import React from 'react'

const styles = () => ({
  'editable-container': {
    display: 'flex',
    justifyContent: 'flex-end',
    '& .input-component': {
      width: '100%',
    },
    '& .value-component': {
      width: '100%',
      // minHeight: 30,
    },
  },
  'edit-icon': {
    fontSize: 18,
    '&:hover': {
      cursor: 'pointer',
    },
  },
})
class EditableField extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isEditing: false,
      showEditIcon: false,
      value: props.value || null,
    }
    this.handleEditIcon = this.handleEditIcon.bind(this)
    this.onChange = this.onChange.bind(this)
    this.handleClick = this.onChange.bind(this)
    this.onSubmitValue = this.onSubmitValue.bind(this)
  }

  onChange(value) {
    this.setState({ value })
  }

  onSubmitValue() {
    const { value } = this.state

    this.props.onChange(value)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isEditing !== this.state.isEditing) {
      this.setState({ isEditing: nextProps.isEditing })
    }
  }

  handleEditIcon(visible) {
    this.setState({ showEditIcon: visible })
  }

  handleClick(e) {
    if (!this.node.contains(e.target)) {
      this.setState({ isEditing: false })
    }
  }

  render() {
    const { className, valueComponent, inputComponent, classes, inputRef } = this.props
    const { isEditing, showEditIcon, value } = this.state
    return (
      <div>
        {/** biome-ignore lint/a11y/noStaticElementInteractions: TODO */}
        <div
          onMouseEnter={() => this.handleEditIcon(true)}
          onMouseLeave={() => this.handleEditIcon(false)}
          className={cn(className, classes['editable-container'])}
        >
          {!isEditing && (
            // biome-ignore lint/a11y/noStaticElementInteractions: TODO
            <div role="presentation" className="value-component" onClick={() => this.setState({ isEditing: true })}>
              {valueComponent}
            </div>
          )}
          {isEditing && (
            // biome-ignore lint/a11y/noStaticElementInteractions: TODO
            <div role="presentation" className="input-component" onBlur={() => this.setState({ isEditing: false })}>
              {{
                ...inputComponent,
                value,
                onChange: evt => this.onChange(evt.target.value),
              }}
            </div>
          )}
          {showEditIcon && !isEditing && (
            <Edit
              className={classes['edit-icon']}
              onClick={() => {
                // biome-ignore lint/complexity/useOptionalChain: TODO
                inputRef && inputRef.focus()
                this.setState({ isEditing: true })
              }}
            />
          )}
        </div>
      </div>
    )
  }
}

EditableField.defaultProps = {
  className: '',
  onChange: () => {},
}

export default withStyles(styles)(EditableField)
